import React from 'react';
import PropTypes from 'prop-types';
import ActInfo from './ActInfo';
import SequenceInfo from './SequenceInfo';
import SceneInfo from './SceneInfo';
import MovieInfo from './MovieInfo';

export default function InfoPanel ({ node }) {
  if (!node) {
    return <div className="p-4 text-muted">Click on any slice for details</div>;
  }

  const map = {
    movie:  MovieInfo,
    act:    ActInfo,
    sequence: SequenceInfo,
    scene:  SceneInfo,
  };
  const Cmp = map[node.type] || (() => <pre>{JSON.stringify(node,null,2)}</pre>);
  return <Cmp data={node} />;
}
InfoPanel.propTypes = { node: PropTypes.object };